export type EventType = {
  type: string;
  [key: string]: any;
};
export class EventBusService {
  private static instance: EventBusService;
  private eventListeners: Map<string, Set<Function>> = new Map();

  private constructor() {}

  public static getInstance(): EventBusService {
    if (!EventBusService.instance) {
      EventBusService.instance = new EventBusService();
    }
    return EventBusService.instance;
  }

  public on<T extends EventType>(
    eventName: T["type"],
    listener: (data: T) => void
  ): () => void {
    if (!this.eventListeners.has(eventName)) {
      this.eventListeners.set(eventName, new Set());
    }
    this.eventListeners.get(eventName)?.add(listener);
    return () => {
      this.off(eventName, listener);
    };
  }

  public off(eventName: string, listener: Function): void {
    this.eventListeners.get(eventName)?.delete(listener);
  }

  public trigger(subscriber: Function, data?: EventType): void {
    this.eventListeners
      .get(data.type)
      ?.forEach((listener) =>
        subscriber != listener ? listener(data) : undefined
      );
  }
}
